import { Dispatch, SetStateAction } from 'react';
import { useMutation, useQueryClient } from 'react-query';

import {
  createReviewRequestRoute,
  errorMessage,
} from '@features/profile';
import axiosInstance from '@server/axiosInstance';
import { profileKey } from '@staffedupusa/shared-components';

type UseReviewRequestCallProps = {
  setErrorText?: Dispatch<SetStateAction<string>>;
};

export const useReviewRequestCall = ({
  setErrorText = () => {},
}: UseReviewRequestCallProps) => {
  const client = useQueryClient();
  const { mutate: createReviewRequest, isLoading: isReviewRequesting } =
    useMutation({
      mutationFn: (variables: {
        name?: string;
        phone?: string;
        best_time?: string;
        company_name?: string | null;
        email?: string;
        manual: boolean;
      }) =>
        axiosInstance
          .post(createReviewRequestRoute, variables)
          .then((res) => res.data),
      onSuccess: (data) => {
        if (data.status !== 200) {
          setErrorText(data.message);
        } else {
          client.invalidateQueries([profileKey]);
          setErrorText('');
        }
      },
      onError: () => setErrorText(errorMessage),
    });

  return {
    createReviewRequest,
    isReviewRequesting,
  };
};
